import { Component, OnInit, Injector, ViewChild, ViewEncapsulation } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DataTable } from 'primeng/components/datatable/datatable';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { LazyLoadEvent } from 'primeng/components/common/lazyloadevent';
import { Paginator } from 'primeng/components/paginator/paginator';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { CreateOrEditEventTypeModalComponent } from '@app/event/event-types/modal/create-or-edit-event-type-modal.component';
import { EventTypesServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  templateUrl: './event-types.component.html',
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()]
})
export class EventTypesComponent extends AppComponentBase {

  @ViewChild('createOrEditEventTypeModal') createOrEditEventTypeModal: CreateOrEditEventTypeModalComponent;
  @ViewChild('dataTable') dataTable: DataTable;
  @ViewChild('paginator') paginator: Paginator;

  //Filters
  filterText = '';

  constructor(
    injector: Injector,
    private _eventTypeService: EventTypesServiceProxy,
    private _fileDownloadService: FileDownloadService
  ) {
    super(injector);
  }

  getEventTypes(event?: LazyLoadEvent) {
    if (this.primengDatatableHelper.shouldResetPaging(event)) {
      this.paginator.changePage(0);

      return;
    }

    this.primengDatatableHelper.showLoadingIndicator();

    this._eventTypeService.getAll(
      this.filterText,
      this.primengDatatableHelper.getSorting(this.dataTable),
      this.primengDatatableHelper.getSkipCount(this.paginator, event),
      this.primengDatatableHelper.getMaxResultCount(this.paginator, event)
    )
    .finally(() => { 
      this.primengDatatableHelper.hideLoadingIndicator(); 
    })
    .subscribe(result => {
      this.primengDatatableHelper.totalRecordsCount = result.totalCount;
      this.primengDatatableHelper.records = result.items;    
    });
  }

  reloadPage(): void {
    this.paginator.changePage(this.paginator.getPage());
  }

  createEventType(): void {
    this.createOrEditEventTypeModal.show();
  }

  deleteEventType(type: any): void {
    let msg = this.l('Event Type') + ' ' + type.description + ' ' + this.l('will be deleted.');

    this.message.confirm(
      msg,
      (isConfirmed) => {
        if (isConfirmed) {
          this._eventTypeService.delete(type.id)
            .subscribe(() => {
              this.reloadPage();
              this.notify.success(this.l('SuccessfullyDeleted'));
            });
        }
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/event/event-types/event-types.component.ts